// extracted by mini-css-extract-plugin
export var atPrefix = "at-prefix_nUoYD5KnYS0mAEXYIHAN";
export var checkingIndicator = "checking-indicator_cWSJICJiigpAdZSDHNNG";
export var domainInputRow = "domain-input-row_EpcAikfAK2Nl8Lq0Ij0L";
export var domainInputWrapper = "domain-input-wrapper_tVObexm0tRxUXsqzYTcr";
export var domainLimitMessage = "domain-limit-message_wHIP5g6JALY61A_BKv4w";
export var domainList = "domain-list_uXKcycE0AoATroJVNWy7";
export var domainListActions = "domain-list-actions_C1GB4jl_2naEhrXqoWoH";
export var domainListItem = "domain-list-item_C4BJ8p_602FKXVThfLT4";
export var domainListItemDeselected = "domain-list-item-deselected_nrqFAmRK_fzkealruaS5";
export var domainListItemUnverified = "domain-list-item-unverified_yic7EYRqvOD2xyvsH5iZ";
export var domainName = "domain-name_r65iE6pGVzJr_Q90aq03";
export var domainNameRow = "domain-name-row_tRQyMQuZV8HtJBfQ1I_T";
export var errorText = "error-text_FYY7ZCDzveJPzmB1Tnyh";
export var helperCode = "helper-code_eHKelyYCAifVg1D8orBv";
export var helperText = "helper-text_ZGAzjdAsd5mabGICOUVj";
export var removeButton = "remove-button_Fkf91L5Jhpc09bQDYP8k";
export var verifiedIndicator = "verified-indicator_R6Qp_C2KNAJ1lOHFPREh";
export var warningIcon = "warning-icon_SRsHMZIxXxyy61JKZKot";
export var warningTooltip = "warning-tooltip_wjSb0aTXdHjiYIA6Bbmf";